import Heading4 from "components/type/Heading4"
import PropTypes from "prop-types"
import React from "react"
import { Accordion, Card as Item } from "react-bootstrap"
// import "./accordion-item.scss"

const AccordionItem = ({
  activeIndex,
  content,
  heading,
  index,
  isAccordion,
}) => {
  return (
    <Item
      aria-label={`${heading} ${
        activeIndex === index ? "Hide the answer" : "Show the answer"
      }`}
      className="accordion-item-wrapper g-accordion-cards-card card"
      tabIndex="0"
    >
      <Accordion.Toggle as={Item.Header} eventKey={index}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="accordion-item-header-wrapper">
            <Heading4 className="accordion-item-title">{heading}</Heading4>
          </div>
          <img
            alt={heading}
            src={`/images/blue-${activeIndex === index ? "minus" : "plus"}.svg`}
            width="30"
          />
        </div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={index}>
        <Item.Body>
          <div
            className="accordion-item-content"
            dangerouslySetInnerHTML={{
              __html: content.childrenMarkdownRemark[0].html,
            }}
          />
        </Item.Body>
      </Accordion.Collapse>
    </Item>
  )
}

AccordionItem.propTypes = {
  activeIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  content: PropTypes.shape({
    childrenMarkdownRemark: PropTypes.arrayOf(
      PropTypes.shape({
        html: PropTypes.string,
      })
    ),
  }),
  heading: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAccordion: PropTypes.bool,
  subHeading: PropTypes.string,
}

export default AccordionItem

// <div className="section-split-accordion-v2--accordion-item">
//       <h3 className="section-split-accordion-v2--accordion-item-title">{heading}</h3>
//       <p className="section-split-accordion-v2--accordion-item-text">{subHeading}</p>
//       <div className="section-split-accordion-v2--accordion-item-content" dangerouslySetInnerHTML={{ __html: content.childrenMarkdownRemark[0].html }} />
//     </div>
